module.exports = __webpack_public_path__ + "RobotoMedium.aeb0047887fe9a886174.eot";


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/fonts/RobotoMedium.eot
// module id = ../../../../../src/fonts/RobotoMedium.eot
// module chunks = 3